<template>
  <div style="height: 100%">
    <table-list
        :height="height"
        @query="handleLoadList"
        :data="tableData"
        :searchParams="searchParams"
        :request-params="{status: 'audit'}"
        :auto="false"
        @selection-change="selection = $event"
        ref="list">
      <el-table-column type="selection" width="50"/>

      <el-table-column :label="$t('编号')" align="center" prop="num" fixed="left" sortable />
      <el-table-column :label="$t('图片')" align="center" prop="cover">
        <template v-slot="{row}">
          <div class="fb-gap-10">
            <preview-img :img-url="row.cover" :size="40" :length="2" />
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('名称')" align="center" prop="name" />

      <el-table-column :label="$t('分类')" align="center" prop="sortName" />

      <el-table-column :label="$t('发布者编号')" align="center" prop="userNum" sortable min-width="100"/>
      <el-table-column :label="$t('发布者昵称')" align="center" prop="username" min-width="100" />
      <el-table-column :label="$t('会员等级')" align="center" prop="vipLevelName" />
      <el-table-column :label="$t('用户状态')" align="center">
        <template v-slot="{row}">
          <dict-text dict-flag="AN_USER_STATUS" :status="row.userBandStatus" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('菜谱属性')" align="center">
        <template v-slot="{row}">
          <dict-text :status="row.property" dict-flag="RECIPE_ATTRS" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('能量值')" align="center" prop="calorie" />
      <el-table-column :label="$t('相似菜谱数')" align="center" sortable prop="sameCount" min-width="120">
        <template v-slot="{row}">
          <el-link type="primary" :underline="false" @click="handleSimilarRecipe(row)">{{ row.sameCount || 0 }}</el-link>
        </template>
      </el-table-column>
<!--  todo 国家没有字段    -->
      <el-table-column :label="$t('使用国家')" align="center" />
      <el-table-column :label="$t('发布时间')" align="center">
        <template v-slot="{row}">{{row.createTime | formatDate}}</template>
      </el-table-column>
      <el-table-column :label="$t('操作')" align="center" min-width="90" fixed="right">
        <template v-slot="{row}">
          <div class="fb-link-flex">
            <el-link type="primary" :underline="false" @click="handleAudit(row)">{{ $t('审核') }}</el-link>
            <el-link type="primary" :underline="false" @click="handleCheckRecipe(row)">{{ $t('查看') }}</el-link>
            <el-link type="danger" :underline="false" @click="handleDeleteRecipe(row)">{{ $t('删除') }}</el-link>
          </div>
        </template>
      </el-table-column>
    </table-list>


    <el-dialog :visible.sync="auditDialog" :close-on-click-modal="false" :append-to-body="true">
      <template #title>
        <h4>{{ $t('菜谱审核') }}</h4>
      </template>

      <el-form label-position="left" label-width="auto" :model="auditFormData" ref="form">
        <el-form-item :label="$t('菜谱编号')">
          <span>{{ auditFormData.num }}</span>
        </el-form-item>

        <el-form-item :label="$t('菜谱名称')">
          <span>{{ auditFormData.name }}</span>
        </el-form-item>

        <el-form-item :label="$t('审核意见')">
          <el-radio-group v-model="auditFormData.auditStatus">
            <el-radio label="pass">{{ $t('通过') }}</el-radio>
            <el-radio label="noPass">{{ $t('不通过') }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="$t('审核备注')">
          <el-input type="textarea" :rows="4" v-model="auditFormData.auditContent" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="handleAuditSubmit" type="primary">{{ $t('确定') }}</el-button>
        <el-button @click="auditDialog = false">{{ $t('取消') }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import recipe_mixin from "@/mixin/recipe_mixin";
import {request} from "@/config/request";
import DictText from "@/components/dict/DictText";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
export default {
  name: "RecipeAudit",
  components: {PreviewImg, DictText, TableList},
  mixins: [recipe_mixin],
  props: {
    onLoad: {
      type: Function,
      default: () => {}
    },
    searchParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    current: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      tableData: [],
      auditDialog: false,
      auditFormData: {
        num: "",
        name: "",
        auditStatus: "pass",
        auditContent: "",
      },
      selection: []
    }
  },
  methods: {
    handleSearch() {
      this.$refs.list.handleSearch();
    },

    async handleLoadList(params, setTotal) {
      try {
        console.log("params", params)
        if(Array.isArray(params.firstTypeCode)) params.firstTypeCode = params.firstTypeCode.join(",");
        let res = await request(this.$api.cookbook.list, params);
        this.tableData = res.cookbooks.map(item => {
          item.coverList = item.cover ? item.cover.split(",") : [];
          item.star = item.star ? item.star.toFixed(2) : 0;
          return item;
        })
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    // 审核
    async handleAudit(row) {
      this.auditDialog = true;
      for (const key in this.auditFormData) {
        this.auditFormData[key] = row[key];
      }
      this.auditFormData.auditStatus = "pass";
    },

    // 审核提交
    async handleAuditSubmit() {
      try {
        await request(this.$api.cookbook.audit, this.auditFormData);
        this.$message.success(this.$t('操作成功'));
        this.auditDialog = false;
        this.$refs.list.handleRequest();
      }catch(e) {
         console.log(e);
      }
    }
  },
  watch: {
    current: {
      handler(val) {
        if(val === "RecipeAudit") {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    },
  }
}
</script>

<style scoped>

/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}

</style>
